// export const MINIMUM_PRICE = 0.01;

import { isAppPWA } from './helper-functions';
import { calculateTotalToPay } from './order/orderUtils';

export const MINIMUM_PRICE = 0.5;
export const isAllowedToPay = (cartItems) => {
  return (
    cartItems &&
    (cartItems.promoPrice >= MINIMUM_PRICE ||
      (cartItems.promoPrice === 0 && cartItems.itemsPrice >= MINIMUM_PRICE))
  );
};

export const isAllowToChangeStore = (storeName) => {
  if (!storeName) return null;
  const exclusiveStores = process.env.REACT_APP_EXCLUSIVE_STORES.split(',');
  return (
    !exclusiveStores.some((element) =>
      storeName.toUpperCase().includes(element),
    ) || isAppPWA()
  );
};
export const isPayzenModule = (store) => {
  return store?.paymentsGateway?.CB === 'payzen';
};
export const isTRavailable = (cartItems) => {
  return !cartItems.some((item) => item.TR === false);
};

export const isLessThan_Minutes = (user, minutes) => {
  const TEN_MINUTES_IN_MS = minutes * 60 * 1000;
  if (!user || !user.createdAt) return false;
  const createdAt = new Date(user.createdAt);
  const currentTime = new Date();
  const differenceInMs = currentTime - createdAt;

  return differenceInMs < TEN_MINUTES_IN_MS;
};

export const isTRissuerExcluded = (issuerName) => {
  const excludedIssuers = process.env.REACT_APP_PAYZEN_EXCLUDED_TR_ISSUER.split(
    ',',
  ).map((issuer) => issuer.trim());
  return excludedIssuers.some((element) =>
    issuerName.toUpperCase().includes(element),
  );
};

export const isStoreHavingPromotion = (store) => {
  return store.api !== 'mongoDb';
};

export const isAppleEcosystem = () => {
  const userAgent = window.navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent); // Detect Safari browser
  const isAppleDevice = /iPhone|iPad|iPod|Macintosh/i.test(userAgent); // Detect Apple devices
  return isAppleDevice || isSafari;
};

export const hasFidelityCard = (user) => {
  return user?.fidCard?.length > 0;
}

export const isStoreIntegrated = (store) => {
  return store?.api !== 'mongoDb';
}
export const isFullName = (name) => {
  return name.trim().split(' ').filter(part => part.length > 0).length > 1;
}

export const isEmailValid = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export const isFullPaymentByJackpot = (cartItems) => {
  if (!cartItems?.jackpot?.amount) return false;
  const finalPrice = cartItems.promoPrice ?? cartItems.itemsPrice;
  return cartItems.jackpot.amount === finalPrice;
}
